import { useMediaQuery } from "@material-ui/core";

export default function useDesktop() {
  const matches = useMediaQuery("(min-width:1024px)");

  return matches;
}
